import { combineReducers } from 'redux';
import { LOCATION_CHANGE } from 'react-router-redux';
import { SET_POPULATION } from './population';
import { types as optionsTypes } from '../actions/options';

export const TOGGLE_CHART = 'chart/TOGGLE';

export const toggleChart = id => ({
  type: TOGGLE_CHART,
  payload: id,
});

const selectedIdReducer = (state = null, action) => {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_CHART:
      return state === payload ? null : payload;

    case SET_POPULATION:
    case optionsTypes.SET_COMPARE:
    case optionsTypes.SET_TIMESPAN:
    case LOCATION_CHANGE:
      return null;

    default:
      return state;
  }
};

export default combineReducers({
  selectedId: selectedIdReducer,
});

export const getSelectedId = state => state.chart.selectedId;



// WEBPACK FOOTER //
// ./src/reducers/chart.js